import React, {Component} from 'react';
import {connect} from 'react-redux';
import PostedApplicationPage from "../components/postedApplicationPage";
import { push } from 'connected-react-router'
import {changeApplicationsAndPoliciesField} from "../actions/applicationsAndPolicies";
import {getApplicationPolicyWording} from "../actions/applicationPolicy";
import {getPostedApplicationMessage} from "../actions/submittedPolicy";
import { POLICY_STATUS_MN_REFERRED, POLICY_STATUS_MN_LIVE } from "../helpers/constants";


class PostedApplicationPageHOC extends Component {

    componentDidMount(){
        // BUG FIX: this used to call getApplicationPolicyWording unconditionally here, which
        // fires GET api/wording/{wordingId} against whatever WordingId the just-created
        // application has. A Draft/Referred application never gets a WordingId (only assigned
        // once the application goes Live - see ApplicationService.AddNotDraftApplicationTask on
        // the backend), so this fired the request with an id that matches no Wording row for
        // every non-Live application, which used to crash the backend endpoint with a
        // NullReferenceException (500) instead of failing gracefully. Backend now returns a
        // clean 404 for that case (see WordingsController.Document / WordingService.GetDtoFromModel),
        // and this guard skips the pointless request entirely when there's no WordingId yet -
        // matching the same guard policyTabHOC.js already had for the same fetch elsewhere.
        if (this.props.postedApplicationPage.postedApplication.wordingId) {
            this.props.getApplicationPolicyWording({wordingId: this.props.postedApplicationPage.postedApplication.wordingId})
        }
        this.props.getPostedApplicationMessage({applicationId:this.props.postedApplicationPage.postedApplication.id})
    }

    shouldRender = () =>{
        let app = this.props.postedApplicationPage.postedApplication;
        let pathname = this.props.router.location.pathname;

        if(app.hasOwnProperty('id')){
            if(pathname.includes(app.id.toString())){
                return true;
            }
            else return false;
        }
        return false;
    };

    policyMessage = () => {
        const machineName = this.props.postedApplicationPage.postedApplication.policyStatusMachineName;
        if(machineName === POLICY_STATUS_MN_REFERRED){
            return <span>Your application has been <strong>Referred</strong> and you will be notified for the progress of your application.</span>
        }
        else if(machineName === POLICY_STATUS_MN_LIVE){
            return <span>Your application has been accepted and the policy is now <strong>Live</strong></span>
        }
        else return null
    }

    render() {
        return (
            <PostedApplicationPage
                fetchingWording={this.props.fetchingWording}
                fetchingPostedApplicationMessage = {this.props.fetchingPostedApplicationMessage}
                wording={this.props.wording}
                postedApplicationMessage= {this.props.postedApplicationMessage}
                policyMessage={this.policyMessage}
                shouldRender={this.shouldRender}
                changeApplicationsAndPoliciesField={this.props.changeApplicationsAndPoliciesField}
                push={this.props.push}
                store={this.props.postedApplicationPage}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        postedApplicationPage: state.postedApplicationPage,
        router:state.router,
        wording: state.applicationPolicy.wording,
        fetchingWording: state.applicationPolicy.fetchingWording,
        postedApplicationMessage: state.submittedPolicy.postedApplicationMessage,
        fetchingPostedApplicationMessage: state.submittedPolicy.fetchingPostedApplicationMessage
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        push: (url) => {
            dispatch(push(url))
        },
        changeApplicationsAndPoliciesField: (key, value) => {
            dispatch(changeApplicationsAndPoliciesField(key, value))
        },
        getApplicationPolicyWording: (payload) => {
            dispatch(getApplicationPolicyWording(payload))
        },
        getPostedApplicationMessage: (payload) => {
            dispatch(getPostedApplicationMessage(payload))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PostedApplicationPageHOC);